import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Loading from "../indicators/Loading";

interface AppDataLoadedFirstProps {
  children: React.ReactNode;
}

const AppDataLoadedFirst: React.FC<AppDataLoadedFirstProps> = ({
  children,
}) => {
  const user = useSelector((state: RootState) => state.user);

  if (user.userDataLoading) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default AppDataLoadedFirst;
